document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-mobile-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  const closeMobile = () => {
    if (!toggle || !drawer) return;
    drawer.removeAttribute('open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Menu openen');
  };
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const willOpen = !drawer.hasAttribute('open');
      drawer.toggleAttribute('open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
      toggle.setAttribute('aria-label', willOpen ? 'Menu sluiten' : 'Menu openen');
      if (willOpen) drawer.querySelector('a')?.focus({preventScroll:true});
    });
    drawer.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMobile));
  }

  const closeDropdowns = (except = null) => {
    document.querySelectorAll('[data-nav-dropdown]').forEach(drop => {
      if (drop === except) return;
      drop.removeAttribute('data-nav-open');
      drop.querySelector('[data-nav-dropdown-toggle]')?.setAttribute('aria-expanded','false');
    });
  };
  document.querySelectorAll('[data-nav-dropdown]').forEach(drop => {
    const btn = drop.querySelector('[data-nav-dropdown-toggle]');
    if (!btn) return;
    btn.addEventListener('click', (event) => {
      event.stopPropagation();
      const open = drop.hasAttribute('data-nav-open');
      closeDropdowns(drop);
      drop.toggleAttribute('data-nav-open', !open);
      btn.setAttribute('aria-expanded', String(!open));
      if (!open) drop.querySelector('[data-nav-dropdown-menu] a')?.focus({preventScroll:true});
    });
  });
  document.addEventListener('click', () => closeDropdowns());

  const dialog = document.querySelector('#OliandaContactDialog');
  document.querySelectorAll('[data-open-contact]').forEach(btn => btn.addEventListener('click', () => {
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  }));
  document.querySelectorAll('[data-close-contact]').forEach(btn => btn.addEventListener('click', () => dialog?.close()));
  if (dialog) {
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMobile();
    closeDropdowns();
    if (dialog?.open) dialog.close();
  });
});
